import { render } from "./PmpkConclusionCard.vue?vue&type=template&id=17c482f0&scoped=true"
import script from "./PmpkConclusionCard.vue?vue&type=script&lang=js"
export * from "./PmpkConclusionCard.vue?vue&type=script&lang=js"

import "./PmpkConclusionCard.vue?vue&type=style&index=0&id=17c482f0&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c482f0"]])

export default __exports__